<template>
  <div class="Login-constructor">
    <div class="Login-content">
      <h1>Frame</h1>
      <h2>登录</h2>
      <el-form
        label-position="top"
        label-width="6.25rem"
        :model="loginTarget"
        :rules="loginRules"
        style="width: 100%"
        ref="loginRef"
      >
        <el-form-item label="用户名" prop="username">
          <el-input v-model="loginTarget.username" @keyup.enter="loginFun" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="loginTarget.password" @keyup.enter="loginFun" />
        </el-form-item>
        <el-form-item 
          label="验证码" prop="verifyCode"
        >
          <el-row :style="{width: '100%'}">
            <el-col :span="16">
              <el-input v-model="loginTarget.verifyCode" @keyup.enter="loginFun" />
            </el-col>
            <el-col :span="6" :offset="2">
              <VerifyCode 
                @randomNumberChange="randomNumberChange"
              />
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <el-button
        type="primary"
        :loading="loginloadFlag"
        @click="loginFun"
        :style="{
          width: '100%'
        }"
      >登录</el-button>
    </div>
  </div>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';
import router from '@/router';

import VerifyCode from '@/components/VerifyCode/index';

import {
  sysLogin,
} from '@/api/Login';

// props
const props = defineProps({
  
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});
const loginTarget = reactive({
  username: '',
  password: '',
  verifyCode: '',
}),
loginRules = reactive({
  username: [
    { required: true, trigger: 'blur', message: "请输入用户名" }
  ],
  password: [
    { required: true, trigger: 'blur', message: "请输入密码" }
  ],
  verifyCode: [
    { required: true, trigger: 'blur', message: "请输入验证码" }
  ]
});
let loginloadFlag = ref(false);
const loginRef = ref();
const loginFun = ()=>{
  loginloadFlag.value = true;
  loginRef.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      sysLoginFun().then(async res=>{
        let messageType = 2;
        if(res.data.code == 1004){
          messageType = 1;
          await store.dispatch('loginInfo', res.data);
          router.push('/');
        }
        message(res.data.msg, messageType);
        loginloadFlag.value = false;
      }).catch(err=>{
        loginloadFlag.value = false;
        console.log(err);
      });
    }else{
      loginloadFlag.value = false;
    }
  })
}

let randomNumber = null;
const randomNumberChange = (val, fn)=>{
  randomNumber = val;
  fn(val);
}

const sysLoginFun = ()=>{
  return sysLogin({
    username: loginTarget.username,
    password: loginTarget.password,
    verifyCode: loginTarget.verifyCode,
    // userEmail: 'N',
    randomNumber: randomNumber,
  });
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.Login-constructor{
  height: 100vh;
  width: 100%;
  background-color: var(--backgroundColor);
  display: flex;
  justify-content: center;
  align-items: center;
  .Login-content{
    width: 600px;
    height: 600px;
    background-color: var(--domBackgroundColor);
    border-radius: 50px;
    padding: 20px 120px;
    display: flex;
    align-content: center;
    flex-wrap: wrap;
    box-shadow: var(--boxShadow);
    h1, h2{
      width: 100%;
      color: var(--titleColor);
      text-align: center;
    }
    .el-form{
      margin: 20px 0;
      .el-form-item__content{
        .el-row{
          height: 32px;
          .el-col{
            height: 100%;
          }
        }
      }
    }
  }
}
</style>